import React from 'react';
import { NavigationCountBadge } from 'shared/components/ui/navigation-count-badge';
import { useTaskCounts } from 'shared/contexts/task-counts';
import { ID } from 'shared/types/id';

export type TagCountProps = {
  tagId: ID;
};

export const TagCount: React.FC<TagCountProps> = ({ tagId }) => {
  const counts = useTaskCounts();

  return <NavigationCountBadge count={counts?.byTagId.get(tagId)} />;
};
